import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { translate } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import { filterArrayOfObjects } from '../../../../../../utils'
import MobileSessionListHeader from './SessionListHeader'
import MobileSessionListItem from './SessionListItem'
import SessionListFilter from  '../SessionListFilter'

const styles = theme => ({
  expandForm: {
    paddingBottom: theme.spacing.unit,
    width: '100%'
  },
  expandColumn: {
    flexBasis: '50%',
    margin: 'auto'
  }
});

class MobileSessionList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sessions: [...this.props.sessions],
      expanded: null
    }
  }

  /* Panel Expand */
  handleExpandChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    })
  }
  /* */

  /* INPUT FILTER */
  filterSessions = filter => {
    const { sessions } = this.props
    this.setState({ sessions: filterArrayOfObjects(sessions, filter) })
  }
  /* */
  
  render() {
    const { recallSession, classes } = this.props
    const { expanded, sessions } = this.state
    const { handleExpandChange, filterSessions } = this

    return (
      <Fragment>
        <SessionListFilter
          className={classes.expandForm}
          onChange={filterSessions}
        />
        <MobileSessionListHeader />
        {sessions.map(session => (
          <MobileSessionListItem 
            key={session.caseId}
            {...session} 
            expanded={expanded === session.caseId}
            handleExpandChange={handleExpandChange}
            recallSession={() => recallSession(session)}
          />
        ))}
      </Fragment>
    )
  }
}

MobileSessionList.propTypes = {
  sessions: PropTypes.array,
  classes: PropTypes.object,
  recallSession: PropTypes.func,
  t: PropTypes.func
}

export default compose(
  translate(),
  withStyles(styles)
)(MobileSessionList)



// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/SessionList/Mobile/SessionList.js